import { useQuery } from '@tanstack/react-query';

import { accountRepo } from '@ctct/domain-layer';

import { QueryKeys } from './constants';
import { useQueryMemoized } from '../helpers/useQueryMemoized';

export const useIsTrialer = () => {
  const query = useQuery({
    queryKey: [QueryKeys.TRIALER],
    queryFn: accountRepo.getIsTrialer,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  return useQueryMemoized(query);
};
